import React, { useRef } from 'react';

import { FormHandles } from '@unform/core';

import ListCars from '@components/lists/ListCars';
import Car from '@models/Car';

import { Container, FormRemove, Sections } from './styles';

interface IProps {
  cars: Car[];
  total: number;
  isLoading: boolean;
}

const FormRemoveVehicle: React.FC<IProps> = ({ cars, total, isLoading }) => {
  const FormRemoveVehicleRef = useRef<FormHandles>(null);

  return (
    <Container>
      <FormRemove
        ref={FormRemoveVehicleRef}
        onSubmit={() => []}
        initialData={{}}
      >
        <Sections>
          <ListCars
            cars={cars}
            loading={isLoading}
            showTotal
            totalValue={total}
          />
        </Sections>
      </FormRemove>
    </Container>
  );
};

export default FormRemoveVehicle;
